import React from "react";
import { Element } from "./Element";

import image1 from "./assets/a1.png";
import image2 from "./assets/a2.png";
import image3 from "./assets/a3.png";
import image4 from "./assets/a4.png";
import { ReactComponent as LinkIcon } from '../../assets/externalLinkIcon.svg';
import advertisement from "./assets/cf.jpg"
import './Ad.scss';

const images = [
    image1, image2, image3, image4
]

function getRandomImage() {
    return images[Math.floor(Math.random() * (images.length))]
}

//getRandomImage();
const PICKED_IMAGE = advertisement;


function Ad({ sequentialId }) {
    return <Element id={sequentialId} isAd={true}>
        <a href="https://tinyurl.com/bdzxnpaj" target="_blank" rel="nofollow">
            <img src={PICKED_IMAGE} alt="Ad" className="ad__im" />
        </a>

        <p className="mb-1">
            Crowded floor. Effortless elegance. ✨
        </p>
        <p className="mb-1">
            Learn to dance elegantly, even on a crowded floor, at our tango workshop. Enjoy a winter escape with the Christmas Tango Ball and festive Budapest tours.
        </p>
        <p className="mb-1">
            Register now! Paid bookings by 20 November will determine whether the workshops go ahead. Full refund if cancelled.

        </p>
        {/* <p className="small text-muted" dangerouslySetInnerHTML={{ __html: typograph(event.note) }} /> */}

        <div className="row no-gutters">
            <div className="col overflow-hidden flex-nowrap display-table-cell pr-2">
                <p className="mb-1">
                    <a href="https://forms.gle/RWSGdJYuon85oEMp9" target="_blank" rel="nofollow">👉 Register</a>
                </p>
            </div>
            <div className="col col-auto">
            <a
                className="btn btn-tc-link"
                href="https://tinyurl.com/bdzxnpaj"
                rel="nofollow"
                target="_blank"
                >
                <span className="svg">
                    <LinkIcon />
                </span>
                    FULL DETAILS
                </a>
            </div>
        </div>
    </Element>
}

export {
    Ad
}